/* eslint-disable react/prop-types */
import React, { Component } from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import CheckIcon from "@material-ui/icons/Check";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";

import ContactForm from "components/ContactForm/ContactForm.jsx";

const styles = {
  pricingSection: {
    padding: "40px 0",
    backgroundColor: "#f5f7fa"
  },
  sectionTitle: {
    textAlign: "center",
    marginBottom: "40px",
    fontSize: "2rem",
    fontWeight: 600,
    color: "#333"
  },
  pricingCard: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    padding: "30px 20px",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    borderRadius: "12px",
    "&:hover": {
      transform: "translateY(-8px)",
      boxShadow: "0 12px 24px rgba(0,0,0,0.15)"
    }
  },
  featuredCard: {
    border: "2px solid #667eea",
    position: "relative"
  },
  featuredBadge: {
    position: "absolute",
    right: "20px",
    backgroundColor: "#667eea",
    color: "white",
    padding: "4px 16px",
    borderRadius: "12px",
    fontSize: "0.75rem",
    fontWeight: 600
  },
  planName: {
    fontSize: "1.5rem",
    fontWeight: 600,
    marginBottom: "16px",
    color: "#333"
  },
  price: {
    fontSize: "2.5rem",
    fontWeight: 700,
    color: "#667eea",
    marginBottom: "8px"
  },
  priceSubtext: {
    fontSize: "0.9rem",
    color: "#666",
    marginBottom: "24px"
  },
  featureList: {
    listStyle: "none",
    padding: 0,
    margin: "24px 0",
    flex: 1
  },
  featureItem: {
    display: "flex",
    alignItems: "center",
    marginBottom: "12px",
    fontSize: "1rem",
    color: "#555"
  },
  checkIcon: {
    color: "#4caf50",
    marginRight: "12px",
    fontSize: "1.2rem"
  },
  ctaButton: {
    marginTop: "auto",
    padding: "12px",
    fontSize: "1rem",
    fontWeight: 600,
    textTransform: "none"
  }
};

class Pricing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contactModalOpen: false
    };
  }

  handleOpenContactModal = () => {
    this.setState({ contactModalOpen: true });
  };

  handleCloseContactModal = () => {
    this.setState({ contactModalOpen: false });
  };

  handleContactFormSuccess = () => {
    // Close modal after successful submission
    this.setState({ contactModalOpen: false });
  };

  render() {
    const { classes } = this.props;
    const { contactModalOpen } = this.state;

    const plans = [
      {
        name: "Basic",
        price: "Free",
        priceSubtext: "Forever free",
        features: [
          "Performance monitoring dashboard",
          "Activity tracking and analytics",
          "One custom training plan",
          "Basic progress tracking",
          "Strava & Garmin integration"
        ],
        buttonText: "Get Started",
        buttonVariant: "outlined",
        buttonColor: "primary",
        featured: false,
        action: () => {
          // For now, do nothing or navigate to signup
          window.location.href = "/signin";
        }
      },
      {
        name: "Custom",
        price: "Let's Talk",
        priceSubtext: "Tailored to your needs",
        features: [
          "Everything in Basic",
          "Unlimited training plans",
          "Advanced physiological assessments",
          "Priority coach consultations",
          "Personalized coaching support",
          "Team and group plans available"
        ],
        buttonText: "Contact Us",
        buttonVariant: "contained",
        buttonColor: "primary",
        featured: true,
        action: this.handleOpenContactModal
      }
    ];

    return (
      <div className={classes.pricingSection}>
        <Typography variant="h2" className={classes.sectionTitle}>
          Choose Your Plan
        </Typography>
        <Grid container spacing={4} justify="center">
          {plans.map((plan, index) => (
            <Grid item xs={12} sm={6} md={5} key={index}>
              <Card
                className={`${classes.pricingCard} ${
                  plan.featured ? classes.featuredCard : ""
                }`}
                elevation={plan.featured ? 8 : 2}
              >
                {plan.featured && (
                  <div className={classes.featuredBadge}>POPULAR</div>
                )}
                <CardContent>
                  <Typography className={classes.planName}>
                    {plan.name}
                  </Typography>
                  <Typography className={classes.price}>
                    {plan.price}
                  </Typography>
                  <Typography className={classes.priceSubtext}>
                    {plan.priceSubtext}
                  </Typography>

                  <ul className={classes.featureList}>
                    {plan.features.map((feature, idx) => (
                      <li key={idx} className={classes.featureItem}>
                        <CheckIcon className={classes.checkIcon} />
                        {feature}
                      </li>
                    ))}
                  </ul>

                  <Button
                    variant={plan.buttonVariant}
                    color={plan.buttonColor}
                    fullWidth
                    className={classes.ctaButton}
                    onClick={plan.action}
                  >
                    {plan.buttonText}
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Contact Us Modal */}
        <Dialog
          open={contactModalOpen}
          onClose={this.handleCloseContactModal}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>
            <Typography variant="h5" style={{ fontWeight: 600 }}>
              Contact Us for Custom Plan
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Typography
              variant="body1"
              style={{ marginBottom: "20px", color: "#666" }}
            >
              Tell us about your training needs and we&apos;ll create a custom
              plan just for you.
            </Typography>
            <Box>
              <ContactForm
                showTitle={false}
                onSubmitSuccess={this.handleContactFormSuccess}
              />
            </Box>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

Pricing.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Pricing);
